/**
 * PKCE primitives for OAuth 2.1 / RFC 7636. Uses the browser's Web Crypto
 * API — no external dependencies.
 *
 * This file is designed to be lifted into other Paybyrd apps unchanged.
 */

function base64UrlEncode(bytes: Uint8Array): string {
  let s = "";
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomBytes(n: number): Uint8Array {
  const buf = new Uint8Array(n);
  crypto.getRandomValues(buf);
  return buf;
}

/** 43-char URL-safe random string. */
export function randomToken(): string {
  return base64UrlEncode(randomBytes(32));
}

/** Returns { codeVerifier, codeChallenge } for an OAuth PKCE flow. */
export async function pkcePair(): Promise<{ codeVerifier: string; codeChallenge: string }> {
  const codeVerifier = randomToken();
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(codeVerifier),
  );
  const codeChallenge = base64UrlEncode(new Uint8Array(digest));
  return { codeVerifier, codeChallenge };
}
